/* eslint-disable */

export const scrollToElement = (id) => {
    const element = document.getElementById(id);
    element.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
};



// WEBPACK FOOTER //
// ./src/components/helpers/scrollToElement.js